import { NavLink } from 'react-router-dom';
import tag from 'blacklist-tag';

export const CleanNavLink = tag(NavLink, [
  'justifyContent',
  'alignItems',
  'flexDirection',
  'maxWidth',
  'renderTabs',
  'hasSubMenu',
  'childLinkActive',
]);



// WEBPACK FOOTER //
// ./src/components/CleanNavLink.tsx